import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

import { fetchChildHeaderDropdownDataByName, fetchHeaderDropdownDataByStringId } from "./FetchData";

export const getHeaderpassDrillDownData: { [key in ModuleConfig]?: ModuleFields[] } = {
  grandchildheader: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter English name",
      validation: { required: "English name is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "grand_child_name_ms",
      className: "col-span-6",
      type: "text",
      name: "grand_child_name_ms",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Malay name",
      // validation: { required: "Malay name is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "grand_child_name_zh",
      className: "col-span-6",
      type: "text",
      name: "grand_child_name_zh",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Mandarin name",
      // validation: { required: "Mandarin name is required" },
    },
    {
      fieldName: "Banner Image",
      fieldValue: "image_url",
      className: "col-span-6",
      name: "image_url",
      formType: "file",
      label: "Banner Image",
      placeholder: "Upload banner image",
      usedFileType: "image",
      type: "image",
      validation: { required: "Banner image is required" },
    },
    // {
    //   fieldName: "Airports ",
    //   fieldValue: "airports_en",
    //   className: "col-span-4",
    //   type: "text",
    //   name: "airports_en",
    //   formType: "input",
    //   label: "Airports",
    //   placeholder: "Enter comma-separated airports",
    // },
    {
      fieldName: "Airports",
      fieldValue: "airports_en",
      className: "col-span-6",
      type: "select",
      name: "airports_en",
      formType: "select",
      label: "Airports",
      placeholder: "Select Airports",
      options: [
        { label: "KLIA1", value: "klia1" },
        { label: "KLIA2", value: "klia2" },
        { label: "Langkawi", value: "langkawi" },
        { label: "Penang", value: "penang" },
        { label: "Kuching", value: "kuching" },
        { label: "Kota Kinabalu", value: "kota-kinabalu" },
      ],
      validation: { required: "Airports selection is required" },
    },

    // {
    //   fieldName: "Grand Child Key ",
    //   fieldValue: "grand_child_key_en",
    //   className: "col-span-4",
    //   type: "text",
    //   name: "grand_child_key_en",
    //   formType: "input",
    //   label: "Grand Child Key ",
    //   placeholder: "Enter key in English",
    //   validation: { required: "English key is required" },
    // },

    {
      fieldName: "Redirect URL ",
      fieldValue: "grand_redirect_url_en",
      className: "col-span-4",
      type: "text",
      name: "grand_redirect_url_en",
      formType: "inputNotes",
      label: "Redirect URL",
      placeholder: "Enter English redirect URL",
      validation: { required: "Redirect URL is required" },
      note: "Click the info icon to learn more before entering a value.",
      uploadTrigger: true,
    },
    {
      fieldName: "Child Heading ID",
      fieldValue: "child_heading_id",
      className: "col-span-6",
      type: "select",
      name: "child_heading_id",
      formType: "multiSelect",
      label: "Child Heading ID",
      placeholder: "Enter child heading ID",
      loadOptions: fetchChildHeaderDropdownDataByName,
      validation: { required: "Child heading ID is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Select if published",
    },
  ],
  childheaders: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name_en",
      className: "col-span-6",
      type: "text",
      name: "name_en",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter English name",
      validation: { required: "English name is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "name_ms",
      className: "col-span-6",
      type: "text",
      name: "name_ms",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Malay name",
      // validation: { required: "Malay name is required" },
    },
    {
      fieldName: "Name (ZS)",
      fieldValue: "name_zh",
      className: "col-span-6",
      type: "text",
      name: "name_zh",
      formType: "input",
      label: "Name (ZS)",
      placeholder: "Enter Mandarin name",
      // validation: { required: "Mandarin name is required" },
    },
    // {
    //   fieldName: "Banner Image",
    //   fieldValue: "image_url",
    //   className: "col-span-6",
    //   name: "image_url",
    //   formType: "file",
    //   label: "Banner Image",
    //   placeholder: "Upload banner image",
    //   usedFileType: "image",
    //   type: "image",
    //   validation: { required: "Banner image is required" },
    // },
    // {
    //   fieldName: "Airports",
    //   fieldValue: "airports_en",
    //   className: "col-span-4",
    //   type: "text",
    //   name: "airports_en",
    //   formType: "input",
    //   label: "Airports",
    //   placeholder: "Enter comma-separated airports",
    // },

    {
      fieldName: "Airports",
      fieldValue: "airports_en",
      className: "col-span-6",
      type: "select",
      name: "airports_en",
      formType: "select",
      label: "Airports",
      placeholder: "Select Airports",
      options: [
        { label: "KLIA1", value: "klia1" },
        { label: "KLIA2", value: "klia2" },
        { label: "Langkawi", value: "langkawi" },
        { label: "Penang", value: "penang" },
        { label: "Kuching", value: "kuching" },
        { label: "Kota Kinabalu", value: "kota-kinabalu" },
      ],
      validation: { required: "Airports selection is required" },
    },

    // {
    //   fieldName: "Child Key ",
    //   fieldValue: "child_key_en",
    //   className: "col-span-4",
    //   type: "text",
    //   name: "child_key_en",
    //   formType: "input",
    //   label: "Child Key (EN)",
    //   placeholder: "Enter key in English",
    //   validation: { required: "English key is required" },
    // },

    {
      fieldName: "Redirect URL ",
      fieldValue: "child_redirect_url_en",
      className: "col-span-6",
      type: "text",
      name: "child_redirect_url_en",
      formType: "inputNotes",
      label: "Redirect URL",
      placeholder: "Enter English redirect URL",
      validation: { required: "Redirect URL is required" },
      note: "Click the info icon to learn more before entering a value.",
      uploadTrigger: true,
    },

    {
      fieldName: "Parent Header",
      fieldValue: "parent_id",
      className: "col-span-6",
      type: "select",
      name: "parent_id",
      formType: "multiSelect",
      label: "Parent Header ",
      loadOptions: fetchHeaderDropdownDataByStringId,
      placeholder: "Enter parent header ",
      validation: { required: "Parent header ID is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Select if published",
    },
  ],
  mainheaders: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter English name",
      validation: { required: "English name is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Malay name",
      // validation: { required: "Malay name is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "name_mandarin",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Mandarin name",
      // validation: { required: "Mandarin name is required" },
    },
    // {
    //   fieldName: "Description",
    //   fieldValue: "description",
    //   className: "col-span-12",
    //   type: "textarea",
    //   name: "description",
    //   formType: "richText",
    //   label: "Description",
    //   placeholder: "Enter description",
    // },
    // {
    //   fieldName: "Banner Image",
    //   fieldValue: "image_url",
    //   className: "col-span-6",
    //   name: "image_url",
    //   formType: "file",
    //   label: "Banner Image",
    //   placeholder: "Upload banner image",
    //   usedFileType: "image",
    //   type: "image",
    //   validation: { required: "Banner image is required" },
    // },
    // {
    //   fieldName: "Airports ",
    //   fieldValue: "airports_en",
    //   className: "col-span-4",
    //   type: "select",
    //   name: "airports_en",
    //   formType: "multiSelect",
    //   label: "Airports",
    //   placeholder: "Enter comma-separated airports",
    // },
    {
      fieldName: "Airports",
      fieldValue: "airports_en",
      className: "col-span-6",
      type: "select",
      name: "airports_en",
      formType: "select",
      label: "Airports",
      placeholder: "Select Airports",
      options: [
        { label: "KLIA1", value: "klia1" },
        { label: "KLIA2", value: "klia2" },
        { label: "Langkawi", value: "langkawi" },
        { label: "Penang", value: "penang" },
        { label: "Kuching", value: "kuching" },
        { label: "Kota Kinabalu", value: "kota-kinabalu" },
      ],
      validation: { required: "Airports selection is required" },
    },

    // {
    //   fieldName: "Key ",
    //   fieldValue: "key_english",
    //   className: "col-span-4",
    //   type: "text",
    //   name: "key_english",
    //   formType: "input",
    //   label: "Key ",
    //   placeholder: "Enter key in English",
    //   validation: { required: "English key is required" },
    // },

    {
      fieldName: "Redirect URL",
      fieldValue: "redirect_english",
      className: "col-span-4",
      type: "text",
      name: "redirect_english",
      formType: "inputNotes",
      label: "Redirect URL",
      placeholder: "Enter English redirect URL",
      validation: { required: "Redirect URL is required" },
      note: "Click the info icon to learn more before entering a value.",
      uploadTrigger: true,
    },

    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Select if published",
    },
  ],
  cardheader: [
    {
      fieldName: "Airport",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name",
      placeholder: "Enter card header name",
      validation: { required: "Name is required" },
    },
    {
      fieldName: "Image URL",
      fieldValue: "image_url",
      className: "col-span-6",
      name: "image_url",
      formType: "file",
      label: "Image URL",
      placeholder: "Upload card header image",
      usedFileType: "image",
      type: "image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Select if published",
    },
  ],
};

export default getHeaderpassDrillDownData;
